import React, { ReactElement } from 'react';

interface BreedGuideTabCardProps {
  title: string;
}

const BreedGuideTabCard: React.FC<BreedGuideTabCardProps> = (data): ReactElement => {
  const { title } = data;

  // Inject self into thumbnail slider

  return (
    <div className="header-tab tab-text w-100" key={title}>
      <span>{title}</span>
    </div>
  );
};

export default BreedGuideTabCard;
